import { AppAction } from "@Safemate/Store/types";
import { TransactionEventFilterEnum } from "../TransactionEnum";
import { TransactionLogActionTypes } from "./actionTypes";
import { Moment } from "moment";

export type SetFilter = (filters: TransactionEventFilterEnum[]) => AppAction<TransactionEventFilterEnum[]>;

export const setFilter: SetFilter = (filters) => ({
  type: TransactionLogActionTypes.SET_FILTER,
  payload: filters
})

export interface FilterDates{
  fromDate: Moment;
  toDate: Moment;
}

export type SetDate = (dates: FilterDates) => AppAction<FilterDates>;

export const setDate: SetDate = (dates) => ({
  type: TransactionLogActionTypes.SET_DATE,
  payload: dates
})

export type SetPage = (page: number) => AppAction<number>;

export const setPage: SetPage = (page) => ({
  type: TransactionLogActionTypes.SET_PAGE,
  payload: page
})

export type SetDetails = (details: boolean) => AppAction<boolean>;

export const setDetails: SetDetails = (details) => ({
  type: TransactionLogActionTypes.SET_DETAILS,
  payload: details
})

export type SetShowPosition = (showPosition: boolean) => AppAction<boolean>;

export const setShowPosition: SetShowPosition = (showPosition) => ({
  type: TransactionLogActionTypes.SET_SHOW_POSITION,
  payload: showPosition
})

export const resetState = () => ({
  type: TransactionLogActionTypes.RESET_STATE
})